import { SicknessesDto } from '../../api/api-types';
import { GET_SICKNESS_DATA } from '../actions';

export const getSicknessDataAction = (data: SicknessesDto) =>
  GET_SICKNESS_DATA({ payload: data });
